export const environment = {
  production: true,
  environmentSite: 'community',
  engineApiSettings: {
    baseUrl: '/api',
  },
  recaptchaSettings: {
    siteKey: '6LfduLEcAAAAAOkvU1NJsHnZpjoya7JdCrSfksnl',
    // theme?: ReCaptchaV2.Theme;
    // type?: ReCaptchaV2.Type;
    // size?: ReCaptchaV2.Size;
    // badge?: ReCaptchaV2.Badge;
  },
  rootPageText: {
    welcomeText: 'Welcome to the',
    titleText: 'Ethic Community Hub',
  },
  rootCssClass: 'app-community-hub',
  loginConfig: {
    ethic: {
      action: '/hub/login',
      method: 'POST',
    },
    zendesk: {
      action: '/auth/zendesk/ssoLogin',
      method: 'POST',
    },
  },
  colorAnimationEnabled: true,
};
